import { render, staticRenderFns } from "./create-study-wizard.vue?vue&type=template&id=0f9006bc&scoped=true&"
import script from "./create-study-wizard.vue?vue&type=script&lang=ts&"
export * from "./create-study-wizard.vue?vue&type=script&lang=ts&"
import style0 from "./create-study-wizard.vue?vue&type=style&index=0&id=0f9006bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9006bc",
  null
  
)

export default component.exports